import { remediationManager } from '../remediation-manager/remediation-manager';
import { prefilter } from './mutation-filters/prefilter';
import { TuningsConfig } from '../config/config';
import { onPostMessage } from '../api/on-post-message';
import { PostMessageType } from '../../constants/base-api';

// TODO FILL THE LIST WITH ATTRIBUTES ALLOWED TO OBSERVE
const allowed: string[] = ['aria-label', 'alt'];
const element: HTMLElement = document.body;
const options = {
  attributes: true,
  attributeFilter: allowed,
  childList: true,
  subtree: true,
};

const observer: MutationObserver = new MutationObserver((domMutations) => {
  const filteredNodes = prefilter(domMutations);
  if (filteredNodes.length) {
    remediationManager.onDomUpdates(filteredNodes);
  }
});

export const initDomObserver = (target = element, config = options): void => {
  if (!TuningsConfig.tech_rem_on_tab) {
    observer.observe(target, config);
  }

  const unsubscribe = onPostMessage(PostMessageType.KeyboardNavEnabled, () => {
    observer.observe(target, config);
    unsubscribe();
  });
};
export const disableDomObserver = (): void => {
  observer.disconnect();
};
